/**
 * When using the NoOpMapsAPILoader, the Google Maps API must be added to the page via a `<script>`
 * Tag.
 * It's important that the Google Maps API script gets loaded first on the page.
 */
var NoOpMapsAPILoader = (function () {
    function NoOpMapsAPILoader() {
    }
    NoOpMapsAPILoader.prototype.load = function () {
        if (!window.google || !window.google.maps) {
            throw new Error('Google Maps API not loaded on page. Make sure window.google.maps is available!');
        }
        return Promise.resolve();
    };
    return NoOpMapsAPILoader;
}());
export { NoOpMapsAPILoader };
//# sourceMappingURL=noop-maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/core/services/maps-api-loader/noop-maps-api-loader.js
// module id = ./node_modules/@agm/core/services/maps-api-loader/noop-maps-api-loader.js
// module chunks = 5